import { InputNumber, Switch } from "antd";
import React, { useEffect, useState } from "react";
import { AiFillMinusCircle } from "react-icons/ai";
import SearchBar from "./SearchBar";
import { formatPrice } from "../utils";
import {
  buildLine,
  getMaxPaidQuantity,
  splitCampaignCodes,
  CAMPAIGN_PRICE,
  CAMPAIGN_BUNDLE,
  CAMPAIGN_GIFT,
} from "../campaign";

const SaleFormProduct = (props) => {
  const { onChange, onDelete, value, bundleActive } = props;

  const [productData, setProductData] = useState(value);

  const product = productData.product;
  const breakdown = buildLine(productData, bundleActive);

  const stock = product ? product.quantity - product.reservedStock : 0;

  // Hediye kampanyası açıkken hediye adedi de stoktan düşeceği için
  // girilebilecek ücretli adet sınırı daralır
  const maxQuantity =
    breakdown.applied && breakdown.type === CAMPAIGN_GIFT
      ? getMaxPaidQuantity(stock, product.campaignGiftQuantity)
      : stock;

  const campaignLabel =
    breakdown.type === CAMPAIGN_PRICE
      ? `${formatPrice(product.campaignPrice)} ₺${
          breakdown.remaining === null
            ? ""
            : ` (kalan ${breakdown.remaining} adet)`
        }`
      : breakdown.type === CAMPAIGN_BUNDLE
        ? `%${product.campaignBundleDiscount} indirim`
        : breakdown.type === CAMPAIGN_GIFT
          ? `Her ${product.campaignGiftQuantity} adette 1 hediye`
          : null;

  // Satırın altında gösterilecek bilgilendirme metinleri
  const hints = [];

  if (
    breakdown.applied &&
    breakdown.normalQuantity > 0 &&
    breakdown.type === CAMPAIGN_PRICE
  ) {
    hints.push(
      `Kontenjan yetmiyor: ${breakdown.campaignQuantity} adet kampanya fiyatından, ${breakdown.normalQuantity} adet normal fiyattan gidecek.`,
    );
  }

  if (breakdown.applied && breakdown.type === CAMPAIGN_GIFT) {
    hints.push(
      `${productData.quantity} adet + ${breakdown.giftQuantity} adet hediye = toplam ${breakdown.totalQuantity} adet stoktan düşecek.`,
    );
  }

  if (product?.campaignPrice && breakdown.remaining === 0) {
    hints.push(
      `${formatPrice(product.campaignPrice)} ₺ kampanya fiyatının kontenjanı doldu, normal fiyattan satılabilir.`,
    );
  }

  if (
    product?.campaignBundleDiscount &&
    !bundleActive &&
    breakdown.type !== CAMPAIGN_BUNDLE
  ) {
    hints.push(
      `${splitCampaignCodes(product.campaignBarcode).join(", ")} kodlu ürünle birlikte satılırsa %${
        product.campaignBundleDiscount
      } indirim uygulanabilir.`,
    );
  }

  if (product?.campaignNote) {
    hints.push(product.campaignNote);
  }

  useEffect(() => {
    onChange(productData);
  }, [productData]);

  return (
    <div className="flex flex-col space-y-1">
      <div className="flex space-x-4 items-end">
        <div className="flex flex-col space-y-1 flex-grow">
          <span>Ürün Seçimi</span>
          <SearchBar
            table="products"
            col="name"
            op="like"
            onChange={(val) => {
              setProductData({
                ...productData,
                product: val,
                // ürün değişince kampanya seçimi sıfırlanır
                useCampaign: false,
              });
            }}
          />
        </div>
        <div className="flex flex-col space-y-1">
          <span>Fiyat</span>
          <span className="pb-1.5 pt-1">
            {product
              ? formatPrice(breakdown.unitPrice || product.price)
              : "NaN"}{" "}
            ₺
          </span>
        </div>
        {campaignLabel ? (
          <div className="flex flex-col space-y-1">
            <span>Kampanya</span>
            <div className="flex items-center space-x-2 pb-1.5 pt-1">
              <Switch
                size="small"
                className={
                  productData.useCampaign ? "bg-green-500" : "bg-slate-500"
                }
                checked={!!productData.useCampaign}
                onChange={(val) =>
                  setProductData({
                    ...productData,
                    useCampaign: val,
                  })
                }
              />
              <span
                className={
                  productData.useCampaign
                    ? "text-green-600 font-semibold"
                    : "text-slate-500"
                }
              >
                {campaignLabel}
              </span>
            </div>
          </div>
        ) : null}
        <div className="flex flex-col space-y-1">
          <span>Stok</span>
          <span className="pb-1.5 pt-1">{product ? stock : "NaN"}</span>
        </div>
        <div className="flex flex-col space-y-1">
          <span>Miktar</span>
          <InputNumber
            value={productData?.quantity}
            onChange={(val) =>
              setProductData({
                ...productData,
                quantity: val,
              })
            }
            max={maxQuantity}
            min={product ? 1 : 0}
          />
        </div>
        {/*
      <div className="flex flex-col space-y-1">
        <span>Ara Toplam</span>
        <span className="pb-1.5 pt-1">
          {productData.product?.price * productData?.quantity} ₺
        </span>
      </div>
      <div className="flex space-x-1 justify-center py-2">
        <span>TL</span>
        <Switch
          className={
            productData.discountType === "percent"
              ? "bg-green-500"
              : "bg-slate-500"
          }
          checked={productData.discountType === "percent"}
          onChange={(val) =>
            setProductData({
              ...productData,
              discountType: val ? "percent" : "amount",
            })
          }
        />
        <span>Yüzde</span>
      </div>
      <div className="flex flex-col space-y-1">
        <span>İskonto</span>
        <InputNumber
          value={productData?.discount}
          onChange={(val) => {
            setProductData({
              ...productData,
              discount: val,
            });
          }}
          min={0}
          max={
            productData.discountType === "percent"
              ? 100
              : productData.product?.price * productData?.quantity
          }
        />
      </div> */}

        <div className="flex flex-col space-y-1 w-20">
          <span>Toplam</span>
          <span className="pb-1.5 pt-1">
            {formatPrice(breakdown.totalAmount)} ₺
          </span>
        </div>
        <span className="py-2">
          <AiFillMinusCircle
            className="text-red-500 text-lg cursor-pointer"
            onClick={() => onDelete(productData.uid)}
          />
        </span>
      </div>
      {hints.length > 0 && (
        <div className="flex flex-col text-xs text-slate-500 pl-1">
          {hints.map((hint, index) => (
            <span key={index}>{hint}</span>
          ))}
        </div>
      )}
    </div>
  );
};

export default SaleFormProduct;
